module.exports = __webpack_public_path__ + "static/media/icon_facebook.cdbba881.svg";